import {
  DateOrNullOrUndefined,
  ForceMap,
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';
import { Objective } from './objective.v2.model';

export class Caregiver {
  index: number = 0;
  nombre: string = '';
  criteria: string = '';
  initiation: Date = new Date();
  caregiver_goal: string = '';
  current_status: string = '';
  outcome_measure: string = '';
  constructor(data: Partial<Caregiver> = {}) {
    this.index = NumberOrNullOrUndefined(data.index) ?? 0;
    this.nombre = StringOrNullOrUndefined(data.nombre) ?? '';
    this.criteria = StringOrNullOrUndefined(data.criteria) ?? '';
    this.initiation = DateOrNullOrUndefined(data.initiation) ?? new Date();
    this.caregiver_goal = StringOrNullOrUndefined(data.caregiver_goal) ?? '';
    this.current_status = StringOrNullOrUndefined(data.current_status) ?? '';
    this.outcome_measure = StringOrNullOrUndefined(data.outcome_measure) ?? '';
  }
}
export class GoalV2 {
  index?: number;
  id: number = 0;
  bip_id: number = 0;
  name: string = '';
  description: string = '';
  baseline_level: number = 0;
  baseline_date: Date = new Date();
  end_date?: Date;
  initial_intensity: number = 0;
  current_intensity: number = 0;
  category: 'maladaptive' | 'sustitution' = 'maladaptive';
  status: 'active' | 'inactive' = 'inactive';
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
  objectives: Objective[] = [];
  caregivers_training_goals?: Caregiver[];
  constructor(data: Partial<GoalV2> = {}) {
    this.index = NumberOrNullOrUndefined(data.index);
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.bip_id = NumberOrNullOrUndefined(data.bip_id) ?? 0;
    this.name = StringOrNullOrUndefined(data.name) ?? '';
    this.description = StringOrNullOrUndefined(data.description) ?? '';
    this.baseline_level = NumberOrNullOrUndefined(data.baseline_level) ?? 0;
    this.baseline_date = DateOrNullOrUndefined(data.baseline_date) ?? new Date();
    this.end_date = DateOrNullOrUndefined(data.end_date);
    this.initial_intensity = NumberOrNullOrUndefined(data.initial_intensity) ?? 0;
    this.current_intensity = NumberOrNullOrUndefined(data.current_intensity) ?? 0;
    this.category = (StringOrNullOrUndefined(data.category) as 'maladaptive' | 'sustitution' | undefined) ?? 'maladaptive';
    this.status = (StringOrNullOrUndefined(data.status) as 'active' | 'inactive' | undefined) ?? 'inactive';
    this.created_at = DateOrNullOrUndefined(data.created_at);
    this.updated_at = DateOrNullOrUndefined(data.updated_at);
    this.deleted_at = DateOrNullOrUndefined(data.deleted_at);
    this.objectives = ForceMap(data.objectives ?? [], Objective);
    this.caregivers_training_goals = (data.caregivers_training_goals ?? []).map((item) => new Caregiver(item));
  }

  static getDefault(): GoalV2 {
    return new GoalV2({
      id: 0,
      bip_id: 0,
      name: '',
      description: '',
      baseline_level: 0,
      baseline_date: new Date(),
      initial_intensity: 0,
      current_intensity: 0,
      category: 'maladaptive',
      status: 'inactive',
      objectives: [],
    });
  }
}
